function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "uploadVideo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 721",
  transform: "translate(79 685)",
  fill: "#fff",
  stroke: "#707070",
  d: "M0 0h24v24H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-79 -685)",
  clipPath: "url(#uploadVideo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 761",
  d: "M79 685h24v24H79z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 762",
  d: "M96 695.5V692a1 1 0 00-1-1H83a1 1 0 00-1 1v10a1 1 0 001 1h12a1 1 0 001-1v-3.5l4 4v-11z",
  fill: "#024ccb"
}));

function SvgUploadVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default SvgUploadVideo;